import { useEffect, useState } from "react";
import { QueryKeys } from "@/Service/Api/V1/QueryKeys/QueryKeys";
import { useQueryClient } from "@tanstack/react-query";
import { useAddToast } from "@/Hooks/useAddToast";

const useBroadcastChannel = (channelName: string) => {
    const queryClient = useQueryClient();
    const addToastMessage = useAddToast();

    const channel = new BroadcastChannel(channelName);
    const [notification, setNotification] = useState<Notification | null>(null);
    useEffect(() => {
        channel.onmessage = (event: MessageEvent) => {
            setNotification(event.data);
            addToastMessage({
                summary: event.data.data.title,
                detail: event.data.data.body,
                severity: 'info'
            });
            if (event.data.action == "refresh-notifications") {
                queryClient.invalidateQueries({ ...QueryKeys.notifications.list() });
                queryClient.invalidateQueries({ ...QueryKeys.notifications.unreadCount });
            }
        };

        // Clean up the channel when the component unmounts
        return () => {
            channel.close();
        };
    }, [channel]);

    const sendNotification = (notification: Notification) => {
        channel.postMessage(notification);
    };

    return { notification, sendNotification };
};

export default useBroadcastChannel;